module.exports = __webpack_public_path__ + "static/record-circular-button-72e2733642599c0e9546eba80b80ccc2.png";